(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["contact-form"] && !Shopify.designMode) return;
  try {
    (() => {
    let installed = false;

    function init() {
      if (installed) return;
      installed = true;

      // After a POST the page reloads with the success or error message
      // rendered. Move focus to the message so keyboard and screen reader
      // users immediately land on the outcome. `autofocus` is inert on a
      // non-control element, so the container is focused programmatically
      // instead. The script is merged once across the site regardless of how
      // many contact forms render, so this stays idempotent.
      const focusMessage = () => {
        const message = document.querySelector('.contact-form__message');
        if (message) message.focus();
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', focusMessage, { once: true });
      } else {
        focusMessage();
      }

      // Guard against double submissions. Contact and footer subscribe forms
      // undergo a full-page POST, so a successful submit navigates away and
      // there is no button state to restore afterwards.
      const isGuardedForm = (form) =>
        form instanceof HTMLFormElement &&
        (form.classList.contains('contact-form__form') ||
          !!form.closest('.contact-form') ||
          form.classList.contains('footer-subscribe__form'));

      document.addEventListener('submit', (event) => {
        const form = event.target;
        if (!isGuardedForm(form)) return;
        if (form.getAttribute('aria-busy') === 'true') {
          event.preventDefault();
          return;
        }
        form.setAttribute('aria-busy', 'true');
        const submitButton = form.querySelector('[type="submit"], button[type="submit"]');
        if (submitButton) submitButton.disabled = true;
      });
    }

    init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["footer-nav-group"] && !Shopify.designMode) return;
  try {
    const mql = window.matchMedia('(min-width: 800px)');
  const navs = document.querySelectorAll('.footer-nav__details');

  function syncOpen() {
    navs.forEach(d => {
      if (mql.matches) d.setAttribute('open', '');
      else d.removeAttribute('open');
    });
  }

  syncOpen();
  mql.addEventListener('change', syncOpen);
  } catch(e) { console.error(e); }
})();

})();
